<template>
  <div>
    <rt-section :title="title" class="detail-table" :iconName="iconName">
      <template slot="toolbar">
        <rt-button type="delete" @click="deleteFile" v-if="canDelete">删除</rt-button>
        <el-button @click="uploadFile" v-if="canUpload">上传</el-button>
      </template>

      <el-table
        :data="dataList"
        ref="gridTable"
        v-loading="loading"
        :header-cell-style="{background:'#F8F9FA'}"
        :row-class-name="tabRowClassName"
      >
        <el-table-column type="selection" width="80%"></el-table-column>
        <el-table-column label="文件名" prop="FileName"></el-table-column>
        <el-table-column label="文件大小(字节)" prop="FileSize"></el-table-column>
        <el-table-column label="操作" align="right">
          <template slot-scope="scope">
            <a
              class="rt-file-list-href"
              :download="scope.row.FileName"
              @click="downloadFile(scope.row)"
            >下载</a>
            <a
              class="rt-file-list-href"
              v-show="/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(scope.row.FileName)"
              @click="previewFile(scope.row)"
            >预览</a>
          </template>
        </el-table-column>
        <template slot="empty">
          <img style="margin-top:50px;" src="../../../src/assets/imgs/home/no-order.png" alt />
          <p class="nodata-prompt">哎呀，暂时没有内容哦～</p>
        </template>
      </el-table>
    </rt-section>
    <el-dialog
      class="middle-dialog"
      width="640px"
      title="上传附件"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-upload
        ref="upload"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :on-change="fileChanged"
        class="upload-demo"
        drag
        :action="fileUploadUrl"
        :headers="config"
        :data="fileData"
        :name="fileName"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
        multiple
        :auto-upload="true"
      >
        <!-- <div v-if="readFileList.length>0">
          <em>点击上传</em>
        </div>-->
        <div>
          <img
            v-if="readFileList.length<=0"
            src="../../../src/assets/imgs/up-load.png"
            alt
            style="margin-top:30px"
          />
          <div class="el-upload__text" :class="{'upload':readFileList.length>0}">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </div>
      </el-upload>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="previewDialog" :before-close="previewClose">
      <img :src="previewImgUrl" style="width: 100%;min-height:500px;" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "RtFileList",
  props: {
    title: {
      type: String,
      default: "注释"
    },
    iconName: {
      type: String,
      default: "注释"
    },
    moduleType: {
      type: String,
      required: true
    },
    objectId: {
      type: String,
      required: true
    },
    canUpload: {
      type: Boolean,
      default: true
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    canDownload: {
      type: Boolean,
      default: true
    },
    canPreview: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dataList: [],
      loading: false,
      dialogVisible: false,
      fileUploadUrl: "../api/attachment/upload",
      fileName: "",
      config: {
        Authorization: "Bearer " + this.$store.state.auth.accessToken
      },
      fileData: {
        ModuleType: this.moduleType,
        FileId: "",
        FileName: this.fileName,
        ObjectId: this.objectId,
        IsOverwrite: "0"
      },
      fileList: [],
      previewImgUrl: "",
      previewDialog: false,
      readFileList: []
    };
  },
  watch: {
    objectId(newVal) {
      if (newVal) {
        this.fileData.ObjectId = newVal;
        this.getDataList();
      }
    }
  },
  methods: {
    //在methods总通过方法计算返回对应class样式
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "even-row";
      }
    },
    getDataList() {
      this.loading = true;
      let apiUrl = `api/attachment?moduleType=${this.moduleType}&objectId=${this.objectId}`;
      rt.get(apiUrl)
        .then(res => {
          this.loading = false;
          this.dataList = res;
        })
        .catch(error => {
          rt.showErrorToast(error);
        });
    },
    // 限制文件大小
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isLt2M;
    },

    //下载附件
    downloadFile(row) {
      window.open(
        rt.getBaseUrl() +
          "api/attachment/download/" +
          this.moduleType +
          "/" +
          row.Id
      );
    },
    previewFile(row) {
      let { FileName, Id } = row;

      let isImage = /\.(png|jpe?g|gif|svg)(\?.*)?$/.test(FileName);
      if (!isImage) return;
      this.previewImgUrl =
        rt.getBaseUrl() +
        "api/attachment/download/" +
        this.moduleType +
        "/" +
        Id;
      this.previewDialog = true;
    },
    previewClose(done) {
      this.previewImgUrl = "";
      done();
    },
    deleteFile() {
      if (!this.canDelete) return;

      let selectedList = this.$refs.gridTable.selection;
      if (selectedList.length === 0) {
        rt.showErrorToast("请至少选择一个文件");
        return;
      }
      var that = this;
      that
        .$confirm("确定删除？", "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let baseUrl = "api/attachment/delete/" + this.moduleType + "/";
          let promiseList = selectedList.map(item => {
            return rt.get(baseUrl + item.Id);
          });
          Promise.all(promiseList)
            .then(() => {
              this.getDataList();
            })
            .catch(error => {
              rt.showErrorToast(error);
            });
        });
    },
    uploadFile() {
      this.dialogVisible = true;
    },
    fileChanged(file, fileList) {
      var errorMessage = "";
      if (!rt.isNullOrWhiteSpace(errorMessage)) {
        this.$message({
          showClose: true,
          message: errorMessage,
          type: "warning"
        });
        fileList.splice(fileList.length - 1, 1);
        return;
      }
      this.attachmentList = fileList;
      this.fileName = file.name;
      this.fileData.FileName = file.name;
      // this.fileList = [];
      // this.fileList.push({
      //   name: file.name,
      //   url: ""
      // });
    },
    uploadSuccess(response, file, fileList) {
      let success = true;
      this.readFileList = fileList;
      fileList.forEach(item => {
        if (item.status !== "success") {
          success = false;
        }
      });
      if (success) {
        this.$message({
          showClose: true,
          message: "附件上传成功！",
          type: "success"
        });
        this.getDataList();
      }

      // 上传成功
      // if (response.ErrorCode == 0) {
      //   this.$message({
      //     showClose: true,
      //     message: file.name + "附件上传成功！",
      //     type: "success"
      //   });
      // } else {
      //   this.$message({
      //     showClose: true,
      //     message: response.Message,
      //     type: "error"
      //   });
      // }
    },
    uploadError(err, file) {
      // 上传失败
      this.$message({
        showClose: true,
        message: err,
        type: "error"
      });
    },
    handleClose(done) {
      this.$refs.upload.clearFiles();
      done();
    }
  }
};
</script>
<style>
.el-upload {
  width: 100%;
}
.upload-demo {
  position: relative;
}
.upload-demo .el-upload-list__item-name {
  height: 26px;
  color: #143e81 !important;
}
.upload-demo .el-upload-list__item-name [class^="el-icon"] {
  height: initial;
}
a.rt-file-list-href {
  cursor: pointer;
  color: #1890ff;
  text-decoration: none;
  font-size: 15px !important;
}
.upload {
  text-align: left !important;
  margin-left: 22px;
}
.el-upload-list {
  position: absolute;
  top: 38%;
  left: 9%;
  right: 9%;
}
.el-upload-list__item {
  background: #f7f9fc;
  padding: 0 22px;
  color: #143e81 !important;
}
.el-upload-list__item-status-label i {
  margin-top: 6px;
}
.el-upload-list__item .el-icon-upload-success {
  color: #55ceb3;
}
</style>



// WEBPACK FOOTER //
// file-list.vue?2ea9fd82